import { AnyAction } from 'redux';
import { rolesPageActionTypes } from '@actions/actionTypes/rolesPage';
import { rolesPageInitialState } from './initialState/rolesPage';

export const rolesPageReducer = (state = rolesPageInitialState, action: AnyAction) => {
  switch (action.type) {
    case rolesPageActionTypes.SET_IS_OPEN_ROLE_DELETE_MODAL: {
      return { ...state, isOpenRoleDeleteModal: action.payload };
    }

    default: {
      return state;
    }
  }
};
